import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { Button } from '@/components/buttons';
import { ImageComponent } from '@/components/Image';

import { ScErrorBlock } from './styled';

interface ErrorBlockProps {
  logo: boolean;
  image?: string;
  text?: React.ReactNode;
  richText?: React.ReactNode;
  buttonText?: string;
  handleOpenSupport?: () => void;
}

export const ErrorBlock: FC<ErrorBlockProps> = ({
  logo,
  text,
  richText,
  buttonText,
  image,
  handleOpenSupport,
}) => {
  const { t } = useTranslation('common');
  const { logo: LogoDesk } = useTheme();

  return (
    <ScErrorBlock>
      {logo && <LogoDesk />}
      {image && (
        <ImageComponent src={image} width={400} height={300} alt="error" />
      )}
      {text && <p>{text}</p>}
      {richText && <div className="rich-text">{richText}</div>}
      <div className="buttonWrap">
        {handleOpenSupport && (
          <Button whiteTransparent small onClick={handleOpenSupport}>
            {t('button.contactUs')}
          </Button>
        )}
        {buttonText && (
          <Button small primary onClick={() => (window.location.href = '/')}>
            {buttonText}
          </Button>
        )}
      </div>
    </ScErrorBlock>
  );
};
